module.exports = "/images/mia.webp?4c51662f922236ed457aa832dadd8871";